import React from 'react';
import {languages,setLanguage,useLanguage} from './index';
import BookingSelect from '../components/BookingSelect';
import CountryFlag from '../components/CountryFlag';
import './LanguagePicker.css';

export default function LanguagePicker({compact=false}) {
  const language=useLanguage();
  if (compact) return <BookingSelect className="loop-header-language" value={language}
    ariaLabel={language==='pt-BR'?'Idioma: Português (Brasil)':'Idioma: Español'} onChange={setLanguage}
    displayValue={<span className="loop-language-value"><CountryFlag code={language==='pt-BR'?'BR':'ES'}/><span>{language==='pt-BR'?'PT':'ES'}</span></span>}
    options={languages.map(item=>({value:item.code,label:<span className="loop-language-value"><CountryFlag code={item.code==='pt-BR'?'BR':'ES'}/><span>{item.name}</span></span>}))}/>;
  return <label className="loop-language-picker"><CountryFlag code={language==='pt-BR'?'BR':'ES'}/><select aria-label="Idioma / Idioma" value={language} onChange={e=>setLanguage(e.target.value)}>{languages.map(l=><option key={l.code} value={l.code}>{l.name}</option>)}</select></label>;
}
